<script setup>
import { provide } from 'vue'
import { useStore } from '@/store/bucket'
import stripslashes, { replaceS3path, formatDate, capitalize } from '@/Shared/helper.js'
import Overlay from '@/Shared/Overlay'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import ModalButtonSet from '@/Shared/Modal/Modal1ButtonSet'
import ButtonSetInBrand from '@/Shared/ButtonSet/ButtonSetInBrand'

const props = defineProps({
  overlay: String,
})

const store = useStore()
const id = store.getModalState.id
const category = store.getModalState.category
const list = store[`get${capitalize(category)}List`]
const data = list.find((item) => id === item[category + 'ID'])

provide('category', category)
provide('list', list)
provide('data', data)

const emit = defineEmits(['close'])
const hasWebSite = data.localWebURL !== '' ? true : false
</script>

<template>
  <div class="modal-container overflow-auto">
    <Overlay v-if="props.overlay !== 'false'" @click="emit('close')" />
    <div class="card w-full z-20 [.touch_&]:mr-[-1px]">
      <ButtonClose :class="{ black: category === 'news' || category === 'brand', white: category === 'shop' }" class="absolute z-20 top-0 right-0 p-[20px] origin-top-right scale-[1.4]" @click="emit('close')" />
      <div class="overflow-y-auto max-h-[80vh] custom-scrollbar">
        <template v-if="category === 'news'">
          <img class="thumb w-full" :src="replaceS3path(data.newsThumb)" :alt="stripslashes(data.newsTitle)" />
          <div class="pt-[25px] pb-[35px] px-[7vw] xs:px-[30px]">
            <div class="font-rift font-bold tracking-[0.02em] text-[15px] mb-2">{{ formatDate(data.newsPubdate) }}</div>
            <h2 class="mb-[15px] text-[16px] font-bold leading-[1.4]">{{ stripslashes(data.newsTitle) }}</h2>
            <ModalButtonSet :url="'/news/' + data.newsCategory + '/' + data.newsSlug" />
          </div>
        </template>

        <template v-if="category === 'brand'">
          <div class="pb-[35px] pt-[7vw] xs:pt-[30px] px-[7vw] xs:px-[30px]">
            <img class="max-w-[140px] max-h-[50px] mb-[10px]" :src="replaceS3path(data.brandThumb)" :alt="stripslashes(data.brandName)" />
            <div class="center-container">
              <img class="w-4/5 mb-[10px]" :src="replaceS3path(data.brandImg)" :alt="stripslashes(data.brandNameLocal)" />
            </div>
            <h2 class="mb-[8px] text-[16px] font-bold leading-[1.4]">{{ stripslashes(data.brandNameLocal) }}</h2>
            <p class="leading-[1.8]">{{ data.brandIntroLead }}</p>
            <div v-if="hasWebSite" class="mt-[30px]">
              <ButtonSetInBrand />
            </div>
            <div v-else>
              <ModalButtonSet :url="'/brands/' + data.brandSlug" />
            </div>
          </div>
        </template>

        <template v-if="category === 'shop'">
          <img class="thumb w-full" :src="replaceS3path(data.shopImg1)" :alt="stripslashes(data.shopNameJ)" />
          <div class="pt-[25px] pb-[35px] px-[7vw] xs:px-[30px]">
            <h2 class="mb-[15px] text-[16px] font-bold leading-[1.4]">{{ stripslashes(data.shopNameJ) }}</h2>
            <table class="shop-info">
              <tr>
                <th>所在地&emsp;：</th>
                <td>{{ data.shopCItyJ + data.shopAddress1J + data.shopAddress2J + data.shopAddress3J }}</td>
              </tr>
              <tr>
                <th>電話番号：</th>
                <td>{{ data.shopTel }}</td>
              </tr>
              <tr>
                <th>営業時間：</th>
                <td v-html="data.shopHours" />
              </tr>
              <tr>
                <th>定休日&emsp;：</th>
                <td v-html="data.shopHoliday" />
              </tr>
            </table>
            <ModalButtonSet :url="'/stores/afcountry/' + data.shopSlug" />
          </div>
        </template>

        <template v-if="category === 'form'">
          <div class="pt-[25px] pb-[35px] px-[7vw] xs:px-[30px]">
            <h2 class="mb-[15px] text-[16px] font-bold leading-[1.4]">form</h2>
            form
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
